import { render, staticRenderFns } from "./btn-text-quarternary3.vue?vue&type=template&id=4f7a7cfa&scoped=true&"
import script from "./btn-text-quarternary3.vue?vue&type=script&lang=js&"
export * from "./btn-text-quarternary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a7cfa",
  null
  
)

export default component.exports